/* eslint-disable */
import React from 'react'
import ReactDOM from 'react-dom'
import debounce from 'lodash.debounce'
import Store from 'react-native-simple-store'
import { parseAnnounce, parseContent } from '../utils/parser'
import dictionary from '../utils/dictionary'
import platform from '../utils/platform'
import store from '../utils/store'
import colors from '../utils/colors'
import TextView from './TextView'
import Image from './Image'
import OptionsPanel from './OptionsPanel'
import { API_URL } from '../config'
import {
  Text,
  StyleSheet,
  View,
  TouchableWithoutFeedback,
  Dimensions,
  PanResponder,
  Animated,
  ActivityIndicator,
  Platform,
} from 'react-native'

const styles = StyleSheet.create({
  overlay: {
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: 'white',
    zIndex: 11,
  },
  
  close: {
    position: 'absolute',
    zIndex: 1,
    right: 0,
    top: 0,
    fontSize: 20,
    paddingTop: 23,
    paddingRight: 15,
    paddingBottom: 10,
    paddingLeft: 20,
  },
  
  containerWrapper: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  
  container: {
    flex: 1,
    justifyContent: 'center',
    backgroundColor: 'white',
    alignItems: 'center',
  },
  
  content: {
    flex: 1,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 55,
    paddingBottom: 55,
    justifyContent: 'center',
    width: '100%',
    maxWidth: 800,
  },
  
  separator: {
    height: Platform.OS == 'ios' ? 20 : 50,
    alignItems: 'center',
    justifyContent: 'center',
  },
  
  separatorInner: {
    width: '30%',
    height: 1,
    backgroundColor: 'black',
  },
  
  containerInner: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    borderRadius: 3,
    paddingLeft: 0.3,
    paddingRight: 0.3,
  },
  
  controls: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  
  controlsArrow: {
    fontSize: 36,
    userSelect: 'none',
    outline: '0',
  },
  
  controlsLeft: {
    height: '100%',
    justifyContent: 'flex-end',
    paddingLeft: 40,
    paddingRight: 80,
    paddingTop: 40,
    paddingBottom: 20,
    outline: '0',
  },
  
  controlsRight: {
    height: '100%',
    justifyContent: 'flex-end',
    paddingLeft: 80,
    paddingRight: 40,
    paddingTop: 40,
    paddingBottom: 20,
    outline: '0',
  },
  
  controlsContainer: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  },
  
  controlsContent: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  },
  
  progressContainer: {
    position: 'absolute',
    left: 10,
    right: 10,
    top: 7,
  },
  
  progress: {
    height: 3,
    backgroundColor: 'rgba(0, 0, 0, 1)',
  },
  
  controlsProgressContainer: {
    position: 'absolute',
    top: '70%',
    left: 50,
    right: 50,
    backgroundColor: 'rgba(255, 255, 255, 1)',
    height: 3,
  },
  
  controlsProgress: {
    backgroundColor: 'rgba(255, 255, 255, 1)',
    height: 3,
  },
  
  controlsProgressHandle: {
    position: 'absolute',
    top: '50%',
    marginTop: -10,
    marginLeft: -10,
    width: 20,
    height: 20,
    borderRadius: 30,
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
  
  infoBar: {
    position: 'absolute',
    left: 10,
    top: 50,
    borderLeftWidth: 5,
    borderLeftColor: '#e50914',
    paddingLeft: 10,
  },
  
  announce: {
    fontSize: 24,
    fontWeight: '300',
    lineHeight: '1.4',
    userSelect: 'none',
  },
  
  cancelContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '100%',
    alignItems: 'center',
  },
  
  cancel: {
    padding: 20,
  },
  
  cancelIcon: {
    fontSize: 40,
    color: 'black',
    userSelect: 'none',
  },
  
  reminderRequestOverlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1,
    backgroundColor: 'white',
    alignItems: 'center',
  },
  
  reminderRequestContent: {
    width: 360,
    flexGrow: 1,
    paddingTop: 45,
  },
  
  reminderRequestTitle: {
    fontFamily: 'Fugaz One',
    fontSize: 32,
    marginBottom: 20,
  },
  
  buttonInverted: {
    color: 'white',
    backgroundColor: 'black',
    textAlign: 'center',
    fontWeight: '600',
    paddingTop: 10,
    paddingBottom: 10,
    userSelect: 'none',
  },
  
  optionsPanel: {
    position: 'absolute',
    bottom: 0,
    left: '50%',
    height: 55,
    width: 100,
    marginLeft: -50,
  },
  
  advancedModeTextVisibleToggle: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: '50%',
    textAlign: 'center',
    paddingTop: 20,
    paddingBottom: 50,
    paddingTop: 50,
    fontSize: 22,
    zIndex: 1,
  },
})

export default class ItemOverlay extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = {
      scenes: [],
      sceneIndex: 0,
      info: {},
      controlsHeight: 55,
      advancedModeTextVisible: false,
    }
    
    this.onUpdateFromTextView = debounce(this.onUpdateFromTextView, 250)
    
    this.keydownEventListener = (event) => {
      switch (event.code) {
        case 'Escape':
        break
        
        case 'ArrowRight':
        case 'Space':
          this.showNextScene()
          event.preventDefault()
        break
        
        case 'ArrowLeft':
          this.showPreviousScene()
          event.preventDefault()
        break
      }
    }
    
    document.addEventListener('keydown', this.keydownEventListener)
    
    this.contentWidth = Math.min(window.innerWidth, 800) - 40
    this.contentHeight = window.innerHeight - 55 - 103
    
    window.addEventListener('resize', () => {
      this.contentWidth = Math.min(window.innerWidth, 800) - 40
      this.contentHeight = window.innerHeight - 55 - 103
    })
  }
  
  loadScenes(itemHistory) {
    this.setState({
      scenes: [],
    })
    
    itemHistory.index = 1
    
    this.fetchScenes(this.props.item, itemHistory.index, ({ scenes }) => {
      const sceneIndex = Math.max(0, Math.min(itemHistory.sceneIndex, scenes.length - 1))
      
      this.setState({
        scenes,
        sceneIndex,
        itemHistoryIndex: itemHistory.index,
      })
    })
  }
  
  componentWillMount() {
    Store.get('history').then((history) => {
      const historyItemId = `${this.props.item.id}@${this.props.languages.original}-${this.props.languages.translated}`
      const itemHistory = (!this.props.asDictionary && history[historyItemId]) || { index: 1, sceneIndex: 0 }
      
      this.loadScenes(itemHistory)
    })
  }
  
  componentWillUnmount() {
    document.removeEventListener('keydown', this.keydownEventListener)
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (this.state.itemHistoryIndex != prevState.itemHistoryIndex ||
        this.state.sceneIndex != prevState.sceneIndex) {
          
      const historyItemId = `${this.props.item.id}@${this.props.languages.original}-${this.props.languages.translated}`
      Store.update('history', {
        [historyItemId]: {
          index: this.state.itemHistoryIndex,
          sceneIndex: this.state.sceneIndex,
          lastOpened: Date.now(),
        }
      })
    }
  }
  
  resetTextSelection() {
    this.originalTextRef &&
    this.originalTextRef.resetTextSelection &&
    this.originalTextRef.resetTextSelection()
    
    this.translatedTextRef &&
    this.translatedTextRef.resetTextSelection &&
    this.translatedTextRef.resetTextSelection()
  }
  
  translate(text, from, to) {
    return fetch(`${API_URL}/translate?text=${text}&from=${from}&to=${to}`)
      .then(response => response.json())
      .then(response => response.translatedText.toLowerCase())
  }
  
  fetchScenes(item, index, callback) {
    const originalLanguage = this.props.languages.original
    const translatedLanguage = this.props.languages.translated
    
    if (this.props.asDictionary) {
      const dictionaryList = dictionary.list(this.getLanguagePair())

      if (!dictionaryList.length) {
        window.alert('Dictionary is empty')
        this.props.onClose()
        return
      }

      callback({
        scenes: dictionaryList.map(item => ({
          type: 'text',
          original: item.original,
          translated: item.translated.translation,
        }))
      })
      return
    }
    
    const fetchOriginal = fetch(`${API_URL}/item?id=${item.id}&language=${originalLanguage}&index=${index}`)
      .then(response => response.json())
      .then(response => response.data)
        
    const fetchTranslated = fetch(`${API_URL}/item?id=${item.id}&language=${translatedLanguage}&index=${index}`)
      .then(response => response.json())
      .then(response => response.data)
        
    Promise
      .all([fetchOriginal, fetchTranslated])
      .then(([original, translated]) => {
        if (translated.length > original.length) {
          original = original.concat(translated.slice(original.length - translated.length))
        }
        
        if (original.length > translated.length) {
          translated = translated.concat(original.slice(translated.length - original.length))
        }
        
        const scenes = original.map((_, index) => {
          const type = original[index].type
          
          if (type == 'text') {
            return {
              type,
              original: original[index].content,
              translated: translated[index].content,
            }
          }
          
          if (type == 'image') {
            return {
              type,
              url: original[index].url,
              resizeMode: original[index].resizeMode,
              backgroundColor: original[index].backgroundColor,
            }
          }
          
          if (type == 'announce') {
            return {
              type,
              content: original[index].content,
            }
          }
        })
        .filter(scene => !(scene.type == 'text' && (!scene.original.trim() || !scene.translated.trim())))
        
        callback({ scenes })
      })
  }
  
  onPressClose() {
    this.props.onClose()
  }
  
  showPreviousScene() {
    if (this.state.scenes.length == 0) return
    
    const sceneIndex = this.state.sceneIndex - 1
    
    this.resetTextSelection()
    
    this.setState({ advancedModeTextVisible: false })
    
    if (sceneIndex == -1) {
      if (this.state.itemHistoryIndex > 1) {
        this.loadScenes({
          index: this.state.itemHistoryIndex - 1,
          sceneIndex: Infinity
        })
      }
    } else {
      this.setState({
        sceneIndex,
      })
      
      if (this.state.scenes[sceneIndex].original == '' || this.state.scenes[sceneIndex].translated == '') {
        this.showPreviousScene()
      }
    }
  }
  
  showNextScene() {
    if (this.state.scenes.length == 0) return
    
    const sceneIndex = this.state.sceneIndex + 1
     
    this.resetTextSelection()
    
    this.setState({ advancedModeTextVisible: false })
    
    if (sceneIndex == this.state.scenes.length) {
      if (this.state.itemHistoryIndex < this.props.item.numberOfEpisodes) {
        this.loadScenes({
          index: this.state.itemHistoryIndex + 1,
          sceneIndex: 0
        })
      }
    } else {
      this.setState({
        sceneIndex,
      })
      
      if (this.state.scenes[sceneIndex].original == '' || this.state.scenes[sceneIndex].translated == '') {
        this.showNextScene()
      }
    }
  }
  
  onPressBackground(event) {
    if (event.nativeEvent.locationX > Dimensions.get('window').width / 2) {
      this.showNextScene()
    } else {
      this.showPreviousScene()
    }
  }
  
  getProgressWidth() {
    return this.state.sceneIndex / (Math.max(2, this.state.scenes.length) - 1) * 100 + '%'
  }
  
  onUpdateFromTextView(type, content, data) {
    if (!data.selection || data.selection.length > 40) return
    
    data.selection = data.selection.toLowerCase()
    
    const ref = type == 'original' ? this.originalTextRef : this.translatedTextRef
    const translateFrom = type == 'original' ? this.props.languages.original : this.props.languages.translated
    const translateTo = type == 'original' ? this.props.languages.translated : (this.props.languages.additional == 'none' ? this.props.languages.original : this.props.languages.additional)
    
    this.translate(data.selection, translateFrom, translateTo).then((translation) => {
      const scene = this.state.scenes[this.state.sceneIndex] || {}
      const currentContent = type == 'original' ? scene.original : scene.translated
      if (currentContent != content) return
      
      ref && ref.update(content, translation, dictionary.has(this.getLanguagePair(), data.selection))
      
      this.textViewTranslation = translation
      this.textViewSelection = data.selection
    })
  }
  
  onOriginalTextHeightChange(event) {
    this.setState({
      controlsHeight: Math.min(80, 55 + Math.max(0, event.containerHeight - event.height))
    })
  }
  
  enableReminder() {
    this.props.emit('enableReminder', {
      settingsPrompt: false
    })
  }
  
  onChangeSlider(value) {
    this.setState({
      sceneIndex: Math.round((this.state.scenes.length - 1) * value),
      advancedModeTextVisible: false,
    })
  }
  
  onAddToDictionary() {
    dictionary.has(this.getLanguagePair(), this.textViewSelection)
      ? dictionary.remove(this.getLanguagePair(), this.textViewSelection)
      : dictionary.add(this.getLanguagePair(), this.textViewSelection, this.textViewTranslation)
  }
  
  getLanguagePair() {
    return `${this.props.languages.original}-${this.props.languages.translated}`
  }
  
  render() {
    const scene = this.state.scenes[this.state.sceneIndex] || {}
    const height = Dimensions.get('window').height
    const C = colors(this.props.settings.nightModeEnabled)
    
    return (
      <View style={[styles.overlay, C.backgroundColorInverted]}>
        <View style={{flex: 1}}>
          {this.props.showReminderRequest &&
            <View style={styles.reminderRequestOverlay}>
              <View style={styles.reminderRequestContent}>
                <Text style={styles.reminderRequestTitle}>make reading a habit</Text>
                <Text style={{fontSize: 19, lineHeight: '1.5', marginBottom: 80}}>
                  The most important thing in language learning is constant practice.
                  Enable reminder to get notifications and build a habit of reading.
                </Text>
                
                <Text style={styles.buttonInverted} onPress={this.enableReminder.bind(this)}>ENABLE REMINDER</Text>
              </View>
            </View>
          }
        
          {this.state.scenes.length == 0 &&
            <View style={[styles.container, C.backgroundColorInverted]}>
              <ActivityIndicator size='small' color={this.props.settings.nightModeEnabled ? 'white' : 'black'} />
            </View>
          }
          
          {this.state.scenes.length != 0 && !this.props.showReminderRequest &&
            <Text style={[styles.close, C.color]} onPress={this.onPressClose.bind(this)}>╳</Text>
          }
          
          {this.state.scenes.length != 0 &&
          <View style={[styles.container, C.backgroundColorInverted]}>
            <TouchableWithoutFeedback accessible={false} onPress={this.showPreviousScene.bind(this)}>
              <View style={{position: 'absolute', top: 0, left: 0, width: 'calc((100% - 800px) / 2)', height: '100%', userSelect: 'none', cursor: 'default'}}></View>
            </TouchableWithoutFeedback>
            
            <TouchableWithoutFeedback accessible={false} onPress={this.showNextScene.bind(this)}>
              <View style={{position: 'absolute', top: 0, right: 0, width: 'calc((100% - 800px) / 2)', height: '100%', userSelect: 'none', cursor: 'default'}}></View>
            </TouchableWithoutFeedback>
          
            <View style={[styles.progressContainer, { backgroundColor: this.props.settings.nightModeEnabled ? 'rgba(255, 255, 255, 0.25)' : 'rgba(0, 0, 0, 0.1)' }]}>
              <View style={[styles.progress, {width: this.getProgressWidth()}, C.backgroundColor]}></View>
            </View>
          
            {scene.type == 'text' &&
            <View style={styles.content}>
              {this.props.settings.advancedModeEnabled && !this.state.advancedModeTextVisible &&
                <Text style={[styles.advancedModeTextVisibleToggle, C.color]} onPress={() => this.setState({advancedModeTextVisible: true})}>
                  ◔_◔
                </Text>
              }
            
              <TextView
                align={'bottom'}
                type={'translated'}
                style={{opacity: this.props.settings.advancedModeEnabled && !this.state.advancedModeTextVisible ? 0 : 1}}
                ref={ref => this.translatedTextRef = ref}
                settings={this.props.settings}
                onEmptySpacePress={this.resetTextSelection.bind(this)}
                enableAddToDictionary={false}
                onUpdate={this.onUpdateFromTextView.bind(this, 'translated', scene.translated)}>
                
                {parseContent(scene.translated, false)}
              </TextView>
              
              <View style={styles.separator}>
                <View style={[styles.separatorInner, C.backgroundColor]}></View>
              </View>
              
              <TextView
                align={'top'}
                type={'original'}
                ref={ref => this.originalTextRef = ref}
                settings={this.props.settings}
                onHeightChange={this.onOriginalTextHeightChange.bind(this)}
                onEmptySpacePress={this.resetTextSelection.bind(this)}
                enableAddToDictionary={true}
                onAddToDictionary={this.onAddToDictionary.bind(this)}
                onUpdate={this.onUpdateFromTextView.bind(this, 'original', scene.original)}>
                
                {parseContent(scene.original, false)}
              </TextView>
            </View>
            }
            
            <OptionsPanel
              style={styles.optionsPanel}
              emit={this.props.emit}
              sliderValue={this.state.sceneIndex / (Math.max(2, this.state.scenes.length) - 1)}
              onChangeSlider={this.onChangeSlider.bind(this)}
              settings={this.props.settings}>
            </OptionsPanel>
          </View>
          }
        </View>
      </View>
    )
  }
}
